import { render, staticRenderFns } from "./PhotographyBookingConfigurator.vue?vue&type=template&id=d63981a4&scoped=true&"
import script from "./PhotographyBookingConfigurator.vue?vue&type=script&lang=js&"
export * from "./PhotographyBookingConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyBookingConfigurator.vue?vue&type=style&index=0&id=d63981a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63981a4",
  null
  
)

export default component.exports